import type { AbstractStoreModelWithParents } from '@y42/feature/git/state';
import { AbstractGitEntityState } from '@y42/feature/git/state';
import {
  CanvasElementType,
  CanvasLayer,
  CanvasObjectPosition,
  CanvasObjectProperties,
  CanvasObjectSize,
  CanvasObjectStyles,
  VisualizationCanvasElement,
} from '@y42/json-schema';
import type { VisualizationTabStoreModel } from '../tab/visualization-tab.model';
import { defaultCanvasObjectProperties, CanvasElementTypeToTypeSettings } from './models';

export class VisualizationCanvasElementGitModel extends VisualizationCanvasElement {
  constructor(model: VisualizationCanvasElementStoreModel) {
    super();
    this.$schema = model.$schema;
    this.type = model.type;
    this.position = model.position;
    this.size = model.size;
    this.zIndex = model.zIndex;
    this.layer = model.layer;
    this.groupId = model.groupId;
    this.angle = model.angle;
    this.typeSettings = model.typeSettings as VisualizationCanvasElement['typeSettings'];
    this.styles = model.styles;
    this.locked = model.locked || false;
    this.objectProperties = model.objectProperties || defaultCanvasObjectProperties;
  }
  /**
   * DO NOT MODIFY ANY PROPERTIES HERE.
   * TO LEARN HOW TO MODIFY CLASSES GENERATED FROM JSON-SCHEMA
   * TAKE A LOOK AT https://y42-com.slab.com/posts/working-with-json-schemas-1hz2gcvj
   */
}

export class VisualizationCanvasElementStoreModel<T extends CanvasElementType = CanvasElementType>
  implements AbstractStoreModelWithParents, Omit<VisualizationCanvasElementGitModel, 'typeSettings'>
{
  constructor(model: VisualizationCanvasElementStoreModel<T>) {
    this.$name = model.$name;
    this.$path = model.$path;
    this.$level = model.$level;
    this.$parent = model.$parent;
    this.$parentFolders = model.$parentFolders;
    Object.assign(this, new VisualizationCanvasElementGitModel(model));
  }

  $name: string;
  $path: string;
  $level: number;
  $parent: string;
  $parentFolders: Array<VisualizationTabStoreModel['$name']>;

  $schema!: string;
  typeSettings!: CanvasElementTypeToTypeSettings[T] | null;
  type!: T;
  position!: CanvasObjectPosition;
  size!: CanvasObjectSize;
  angle!: number;
  styles!: CanvasObjectStyles;
  zIndex!: number;
  layer!: CanvasLayer;
  groupId?: string;
  locked!: boolean;
  objectProperties!: CanvasObjectProperties;
}

export { VisualizationCanvasElementStoreModel as CanvasElement };

export type VisualizationCanvasElementUIModel<T extends CanvasElementType = CanvasElementType> =
  VisualizationCanvasElementStoreModel<T> & {
    tab: VisualizationTabStoreModel;
  };

export type VisualizationCanvasElementState = AbstractGitEntityState<VisualizationCanvasElementStoreModel> & {
  ui: VisualizationCanvasElementStateUI;
};

export interface VisualizationCanvasElementStateUI {
  currentSelectionIds: string[];
  clipboard?: VisualizationCanvasElementUIModel[];
}
